import React from "react";
import { styled } from "@mui/material/styles";

const CircleContainer = styled("div")(({ radius, imageUrl }) => ({
  width: `100%`, // Diameter of the circle
  height: `${radius * 2}px`, // Diameter of the circle
  position: "relative",
  overflow: "hidden",
  backgroundColor: "transparent",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundImage: imageUrl ? `url(${imageUrl})` : "none", // Background image
  backgroundSize: `${radius}px ${radius}px`,
  backgroundPosition: "50% 50%",
  backgroundRepeat: "no-repeat", // No repeat
}));

const CircularText = styled("div")(({ radius, fontSize }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: `${fontSize}px`, // Dynamic font size
}));

const calculateFontSize = (radius, textLength) => {
  // Calculate circumference
  const circumference = 2 * Math.PI * radius;
  // Estimate font size that fits text within circumference
  const fontSize = circumference / textLength;
  // Set a maximum font size to ensure readability
  return Math.max(fontSize, 20); // Adjust maximum size as needed
};

const CircularTextComponent = ({ text, radius, imageUrl }) => {
  const textLength = text.length;
  const fontSize = calculateFontSize(radius, textLength);

  return (
    <CircleContainer radius={radius} imageUrl={imageUrl}>
      <CircularText radius={radius} fontSize={fontSize}>
        {Array.from(text).map((char, index) => (
          <div
            key={index}
            style={{
              position: "absolute",
              transform: `rotate(${
                (360 / textLength) * index
              }deg) translateY(-${radius * 0.9}px)`,
              transformOrigin: "0 0",
              whiteSpace: "nowrap",
            }}
          >
            {char}
          </div>
        ))}
      </CircularText>
    </CircleContainer>
  );
};

export default CircularTextComponent;
